// Loaded Event Listener For DOM Events
document.addEventListener("DOMContentLoaded", function (event) {
  // Newsletter Signup - Add to Braze (refactor to use Commerce API)
  const newsletter = document.getElementById("newsletterSubmit");
  if (newsletter) {
    newsletter.addEventListener("click", function () {
      submitEmailClicked();
    });
  }
  // Order Attribution - Add to Braze (refactor to use Commerce API)
  const attribution = document.getElementById("attributionSubmit");
  if (attribution) {
    attribution.addEventListener("click", function () {
      submitAttributionClicked();
    });
  }

  document.getElementById('textSignupInput').addEventListener('blur', function (e) {
    var x = e.target.value.replace(/\D/g, '').match(/(\d{3})(\d{3})(\d{4})/);
    e.target.value = x[1] + '-' + x[2] + '-' + x[3];
  });

  const textSingup = document.getElementById("textSignupSubmit");
  if(textSingup) {
    textSingup.addEventListener("click", function() {
      textSingupClicked();
    });
  }
});




function signupBraze(_email) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append(
    "Authorization",
    "Bearer 9451e9b6-c98f-46f9-9600-4b9e18279ffe"
  );

  var raw = JSON.stringify({
    subscription_group_id: "4cbba201-20a1-4566-a882-a793ca767644",
    subscription_state: "subscribed",
    external_id: "",
    email: _email,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  fetch("https://rest.iad-03.braze.com/subscription/status/set", requestOptions)
    .then((response) => response.json())
    .then((result) => {
      if (result.message !== "success") {
        brazeError(result.message);
      } else {
        brazeSuccess();
      }
    })
    .catch((error) => brazeError(error));

  // Data Layer - NewsletterSignup
  dataLayer.newsletterSignup(_email);
}

function submitEmailClicked() {
  var email = document.getElementById("newsletterInput").value;
  if (email) {
    signupBraze(email);
  } else {
    brazeError();
  }
}

function brazeSuccess() {
  const error = document.getElementById("newsletterError");
  error.classList.remove("d-block");
  const thanks = document.getElementById("newsletterThanks");
  thanks.classList.add("d-block");
  const input = document.getElementById("newsletterInput");
  thanks.classList.add("thanks");
  setTimeout(function(){
    thanks.classList.remove("d-block");
  },6000)
}

function brazeError(_message) {
  console.log(_message);
  const thanks = document.getElementById("newsletterThanks");
  thanks.classList.remove("d-block");
  const error = document.getElementById("newsletterError");
  if (_message !== "") {
    const msg = document.getElementById("newsletterErrorMsg");
    if (msg) {
      _message === undefined ? msg.innerHTML = "Please enter a valid email address" : msg.innerHTML = _message;
      msg.classList.add("d-block");
    }
  }
  error.classList.add("d-block");
  setTimeout(function(){
    error.classList.remove("d-block");
  },6000)
}

function airtableSubmitAttribution(_package) {
  const data = _package;

  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer keyShvHvOAmFUqDcM");
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Cookie", "brw=brwWFBat5pp9FNroe");

  var raw = JSON.stringify({
    records: [
      {
        fields: {
          "Order Number": data.orderNumber,
          "Order Name": data.orderName,
          Attribution: data.attribution,
        },
      },
    ],
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  fetch("https://api.airtable.com/v0/app7bHbusYBsERJR9/Dev", requestOptions)
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.log("error", error));
}

function textSingupClicked() {
  var number = document.getElementById("textSignupInput").value;
  var consentChecked  = document.getElementById('textSignupAgreeToReceive').checked;

  if(number == '' || !isValidPhoneNumber(number)) { 
    textSignupError('phoneNumberError');
    return;
  }

  if(isValidPhoneNumber(number) && !consentChecked) {
    textSignupError('consentError');
    return;
  }

  if(isValidPhoneNumber(number) && consentChecked) {
    submitPhoneNumber(number);
  } else {
    textSignupError('phoneNumberError');
  }
}

function submitPhoneNumber(_number) {
  const textSignup = document.getElementById('textSignup');
  const apiURL = textSignup.getAttribute('data-api');

  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    phone: _number,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  fetch(apiURL, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      if (!result.subscriptionResponses) {
        textSignupError('phoneNumberError');
      } else {
        textSignupSuccess();
      }
    })
    .catch((error) => { 
      textSignupError('phoneNumberError');
    });
}

function isValidPhoneNumber(number) {
  const regex = /^[2-9]\d{2}-\d{3}-\d{4}$/gm;
  return regex.test(number);
}

function textSignupError(errorType) {
  const thanks = document.getElementById("textSignupSucess");
  const phoneNumberError = document.getElementById("textSignupError");
  const textSignupAgreeToReceiveError = document.getElementById('textSignupAgreeToReceiveError');

  if(errorType === 'phoneNumberError') {
    thanks.classList.remove("d-block");
    phoneNumberError.classList.add("d-block");
    setTimeout(function() {
      phoneNumberError.classList.remove("d-block");
    },6000)    
  } else if (errorType === 'consentError') {
    thanks.classList.remove("d-block");
    textSignupAgreeToReceiveError.classList.add("d-block");
    setTimeout(function() {
      textSignupAgreeToReceiveError.classList.remove("d-block");
    },6000)  
  }
}

function textSignupSuccess() {
  const phoneNumberError = document.getElementById("textSignupError");
  const input = document.getElementById("textSignupInput");
  const textSignupAgreeToReceiveError = document.getElementById('textSignupAgreeToReceiveError');
  const consentChecked  = document.getElementById('textSignupAgreeToReceive');
  phoneNumberError.classList.remove("d-block");
  textSignupAgreeToReceiveError.classList.remove("d-block");
  const thanks = document.getElementById("textSignupSucess");
  thanks.classList.add("d-block");
  input.value = '';
  consentChecked.checked = false;
  thanks.classList.add("thanks");
  setTimeout(function(){
    thanks.classList.remove("d-block");
  },6000)
}

// OS detection uses the userAgent, platform is unreliable for Android
// https://stackoverflow.com/questions/21741841/detecting-ios-android-operating-system?rq=1
function toggleStoreIcons() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  const isAndroid = ua.includes("Android");
  if (isAndroid) {
    const appStore = document.getElementById("app_store_link");
    appStore.style.display = "none";
  }

  const isIOS = /iPad|iPhone|iPod/.test(ua);
  if (isIOS) {
    const playStore = document.getElementById("play_store_link");
    playStore.style.display = "none";
  }
}
window.onload = (event) => {
  toggleStoreIcons();
};
